<template>

  <div>

    <div style="width: 100%; position: relative">
       <!-- <div style="white-space: pre-line; text-align: left">
        {{ formatImeiList(productItem) }}
      </div> -->
      <div
        v-if="showChoose"
        class="imei-choose-trigger"
        style="
          display: inline-block;
          transform: translateY(10px);
          margin-left: 4px;
          font-size: 12px;
          max-width: 100%;
        "
      >
        <div style="cursor: pointer; white-space: nowrap">
          <span
            style="font-size: 12px; cursor: pointer"
            class="text-primary"
            @click.stop="addProductImei"
          >
            <i class="fas fa-list-ul text-primary"></i> Chọn IMEI
          </span>
        </div>
      </div>

      <div
        v-else
        style="
          display: inline-block;
          transform: translateY(10px);
          margin-left: 4px;
          font-size: 12px;
          cursor: pointer;
          white-space: nowrap;
        "
      >
         <span
          style="font-size: 12px; cursor: pointer"
          class="text-primary"
          @click.stop="inputProductImei"
          > <i class="fas fa-list-ul text-primary"></i> Nhập IMEI </span
        >
      </div>

    </div>
     <b-modal
      ref="modal-choose-imei"
      size="lg"
      hide-footer
      :id="modalChooseId"
      > <template #modal-title
        >
        <h5
          v-html="titleModal"
          class="mb-0"
        ></h5>
         </template
      >
      <div class="mb-4">
         <template
          >
          <div class="imei-choose-toolbar mb-3">
            <b-form-group
              label="Chọn IMEI:"
              class="imei-choose-toolbar__search mb-0"
            >
              <b-input
                placeholder="Nhập IMEI"
                v-model="apiParams.imeiSearch"
                size="sm"
                autocomplete="off"
                @keyup="onKeyUp"
              ></b-input>
            </b-form-group>
            <div class="imei-choose-toolbar__excel">
              <button
                class="btn btn-secondary font-weight-bolder btn-sm imei-choose-toolbar__excel-btn"
                type="button"
                @click="showModalImport(true)"
              >
                <i class="far fa-file-excel imei-choose-toolbar__excel-icon"></i>
                Nhập từ excel
              </button>
            </div>
          </div>
          <b-table
            :items="products"
            :fields="productFields"
            :per-page="perPage"
            :current-page="currentPage"
            :busy="isLoadingList"
            bordered
            hover
            > <template #table-busy
              >
              <div class="text-center text-danger my-2">
                 <vcl-table
                  :speed="5"
                  :animate="true"
                  :columns="10"
                ></vcl-table
                >
              </div>
               </template
            > <template v-slot:cell(actions)="row"
              >
              <div class="d-flex justify-content-center">
                 <b-form-checkbox
                  size="lg"
                  v-model="row.item.selected"
                ></b-form-checkbox
                >
              </div>
               </template
            > </b-table
          > </template
        >
      </div>
       <b-overlay
        rounded
        opacity="0.6"
        class="d-inline-block mr-3"
        @hidden="$refs.button.focus()"
        > <template #overlay
          >
          <div class="d-flex align-items-center">
             <b-spinner
              variant="light"
              small
              type="grow"
            ></b-spinner
            >
          </div>
           </template
        > <b-button
          :disabled="!products.length"
          variant="primary"
          size="sm"
          @click="onApplyProducts"
          > <v-icon
            small
            class="text-white"
            v-b-tooltip
            >mdi-download</v-icon
          > <strong>Áp dụng</strong> </b-button
        > </b-overlay
      > <b-button
        style="width: 80px"
        variant="secondary"
        size="sm"
        @click="$refs['modal-choose-imei'].hide()"
        > <strong>Hủy</strong> </b-button
      > </b-modal
    > <b-modal
      ref="modal-input-imei"
      size="lg"
      hide-footer
      :id="modalInputId"
      > <template #modal-title
        >
        <h5
          v-html="titleModal"
          class="mb-0"
        ></h5>
         </template
      > <b-row
        > <b-col cols="4"
          > <b-form-group label="Chọn IMEI:"
            > <b-input
              placeholder="Nhập IMEI"
              v-model="imeiInput"
              size="sm"
              autocomplete="off"
              @keyup.enter="onKeyUpImeiInput"
            ></b-input
            > </b-form-group
          > </b-col
        > <b-col cols="4"
          > <b-button
            variant="primary"
            size="sm"
            @click="onKeyUpImeiInput"
            style="margin-top: 28px"
            > <v-icon
              small
              class="text-white"
              v-b-tooltip
              >mdi-plus</v-icon
            > <strong>Thêm IMEI</strong> </b-button
          > </b-col
        > <b-col cols="4"
          >
          <div class="d-flex justify-content-end">
             <button
              style="margin-top: 28px"
              class="btn btn-secondary font-weight-bolder btn-sm"
              type="button"
              @click="showModalImport(false)"
            >
               <i
                style="font-size: 1rem"
                class="far fa-file-excel"
              ></i
              > Nhập từ excel </button
            >
          </div>
           </b-col
        > </b-row
      > <b-table
        :items="inputImeis"
        :fields="productFields"
        :per-page="perPage"
        :current-page="currentPage"
        bordered
        hover
        > <template #table-busy
          >
          <div class="text-center text-danger my-2">
             <vcl-table
              :speed="5"
              :animate="true"
              :columns="10"
            ></vcl-table
            >
          </div>
           </template
        > <template v-slot:cell(actions)="row"
          >
          <div class="d-flex justify-content-center">
             <span
              style="color: #3f4254; font-size: 12px; cursor: pointer"
              @click="onRemoveImei(row.item.imeiCode)"
              > <i
                style="font-size: 1rem; color: #d33"
                class="flaticon2-rubbish-bin-delete-button"
              ></i
              > </span
            >
          </div>
           </template
        > </b-table
      > <b-pagination
        v-show="inputImeis.length > perPage"
        v-model="currentPage"
        :total-rows="inputImeis.length"
        :per-page="perPage"
        align="right"
        size="sm"
        class="mb-0"
        aria-controls="my-table"
      ></b-pagination
      > <b-row
        > <b-col cols="4"
          > <b-button
            variant="primary"
            size="sm"
            @click="onApplyImeis"
            style="margin-right: 10px"
            :disabled="!inputImeis.length"
            > <strong>Áp dụng</strong> </b-button
          > <b-button
            style="width: 80px"
            variant="secondary"
            size="sm"
            @click="$refs['modal-input-imei'].hide()"
            > <strong>Hủy</strong> </b-button
          > </b-col
        > </b-row
      > </b-modal
    > <ImportImei
      ref="importImeiModal"
      @saveData="onSaveDataImportImei"
    />
  </div>

</template>

<script>
  import ApiService from '@/core/services/api.service'
  import { VclTable } from 'vue-content-loading'
  import { cloneDeep, convertPrice, makeToastFaile, makeToastSuccess } from '@/utils/common'
  import { TIME_TRIGGER } from '@/utils/constants'
  import ImportImei from './import-excels/ImportImei.vue'
  import { parseImeiCodes } from '@/view/components/bills/helpers/wholesaleImeiBillTransform'
  import {
    applyChooseImeis,
    applyManualImeis,
    normalizeImeiCode as normalizeImeiCodeFn,
  } from './imeiInputForm.logic'

  export default {
    props: {
      productItem: {
        type: Object,
        required: true,
      },
      tdWidth: {
        type: Number,
      },
      quantityKey: {
        type: String,
        default: 'quantity',
      },
      storeId: {
        type: Number,
      },
      showChoose: {
        type: Boolean,
      },
      statusViews: {
        type: Array,
        default: () => [1],
      },
    },
    data() {
      return {
        titleModal: `IMEI cho sản phẩm <span class='font-weight-bolder text-dark'>${''}</span>`,
        apiParams: {
          imeiSearch: null,
        },
        imeiInput: '',
        products: [],
        inputImeis: [],
        productFields: [
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { fontWeight: 600, color: '#181c32', width: '95%' },
          },
          { key: 'actions', label: '' },
        ],
        productsTerm: [],
        currentPage: 1,
        perPage: 50,
        isLoadingList: false,
        modalChooseId: '',
        modalInputId: '',
        importFromChooseModal: false,
      }
    },
    components: {
      VclTable,
      ImportImei,
    },
    created() {
      // Generate unique modal IDs for each component instance
      const uniqueId =
        this.productItem.productId ||
        `imei-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      this.modalChooseId = `modal-choose-imei-${uniqueId}`
      this.modalInputId = `modal-input-imei-${uniqueId}`
      this.ensureImeiFieldFromImeiCode()

      this.titleModal = `IMEI cho sản phẩm <span class='font-weight-bolder text-dark'>${this.productItem.productName}</span>`
      if (this.showChoose) {
        this.getProductImei(this.productItem, this.storeId)
      }
    },
    computed: {
      selectedImeiSummary() {
        const raw = (this.productItem.IMEI || this.productItem.imeiCode || '').trim()
        if (!raw) return ''
        const codes = parseImeiCodes(raw)
        return codes.length ? codes.join(', ') : ''
      },
    },
    watch: {
      'productItem.imeiCode': {
        handler() {
          this.ensureImeiFieldFromImeiCode()
        },
      },
    },
    methods: {
      convertPrice,
      ensureImeiFieldFromImeiCode() {
        const fromCode = (this.productItem.imeiCode || '').trim()
        const fromImei = (this.productItem.IMEI || '').trim()
        if (!fromImei && fromCode) {
          this.$set(this.productItem, 'IMEI', fromCode)
        }
        const imeiString = (this.productItem.IMEI || this.productItem.imeiCode || '').trim()
        const n = imeiString ? parseImeiCodes(imeiString).length : 0
        this.productItem[this.quantityKey] = n
      },
      appendMissingSelectedImeisToList(products, product, currentImeis) {
        const seen = new Set(
          products.map((p) => this.normalizeImeiCode(p.imeiCode || p.imeiNo)),
        )
        currentImeis.forEach((code) => {
          const c = this.normalizeImeiCode(code)
          if (!c || seen.has(c)) return
          seen.add(c)
          products.push({
            id: `bill-imei-${c}`,
            imeiNo: c,
            imeiCode: c,
            productName: product.productName,
            selected: true,
            sellingPrice: product.sellingPriceMask || product.sellingPrice || 0,
          })
        })
      },
      addProductImei() {
        this.closeAllModals()
        this.titleModal = `IMEI cho sản phẩm <span class='font-weight-bolder text-dark'>${this.productItem.productName}</span>`
        this.apiParams.imeiSearch = null
        this.currentPage = 1
        if (this.showChoose) {
          this.getProductImei(this.productItem, this.storeId)
        }
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs['modal-choose-imei']) {
              this.$refs['modal-choose-imei'].show()
            }
          }, 150)
        })
      },
      inputProductImei() {
        this.closeAllModals()
        this.titleModal = `IMEI cho sản phẩm <span class='font-weight-bolder text-dark'>${this.productItem.productName}</span>`

        const imeiString = this.productItem.IMEI ? this.productItem.IMEI.trim() : ''
        const imeiCodes = imeiString
          ? imeiString
              .split(',')
              .map((code) => code.trim())
              .filter((code) => code)
          : []
        // Tạo mảng mới để đảm bảo Vue detect được thay đổi
        this.inputImeis = imeiCodes.map((imeiCode) => {
          return {
            imeiCode: this.normalizeImeiCode(imeiCode),
            selected: true,
          }
        })
        // Reset current page về 1 khi mở modal
        this.currentPage = 1
        // Đợi một chút để modal đóng hoàn toàn trước khi mở modal khác
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs['modal-input-imei']) {
              this.$refs['modal-input-imei'].show()
              // Force update để đảm bảo bảng được render lại
              this.$forceUpdate()
            }
          }, 150)
        })
      },
      closeAllModals() {
        // Đóng tất cả modal bằng cả ref và ID để đảm bảo
        try {
          if (this.$refs['modal-choose-imei']) {
            this.$refs['modal-choose-imei'].hide()
          }
          if (this.$refs['modal-input-imei']) {
            this.$refs['modal-input-imei'].hide()
          }
        } catch (e) {
          // Ignore errors
        }
        try {
          this.$bvModal.hide(this.modalChooseId)
          this.$bvModal.hide(this.modalInputId)
        } catch (e) {
          // Ignore errors
        }
      },
      getProductImei(product, storeId) {
        this.isLoadingList = true
        const params = {
          productId: product.productId,
          storeId: storeId,
          imeiStatus: this.statusViews,
        }

        const imeiRaw = (this.productItem.IMEI || this.productItem.imeiCode || '').trim()
        const currentImeis = imeiRaw ? parseImeiCodes(imeiRaw) : []

        ApiService.query('imeis/get-by-product', {
          params,
        })
          .then((response) => {
            const { data } = response.data
            const products = []

            ;(data || []).forEach((element) => {
              const isSelected = currentImeis.includes(element.imeiNo)

              const imeiCodes = imeiRaw ? parseImeiCodes(imeiRaw) : []
              const index = imeiCodes.findIndex((imeiCode) => imeiCode === element.imeiNo)
              products.push({
                ...element,
                productName: product.productName,
                imeiCode: element.imeiNo,
                selected: isSelected || index > -1,
              })
            })

            this.appendMissingSelectedImeisToList(products, product, currentImeis)

            setTimeout(() => {
              this.isLoadingList = false
            }, TIME_TRIGGER)
            this.products = cloneDeep(products)
            this.productsTerm = cloneDeep(products)
          })
          .catch(() => {
            const products = []
            this.appendMissingSelectedImeisToList(products, product, currentImeis)
            this.products = cloneDeep(products)
            this.productsTerm = cloneDeep(products)
            this.isLoadingList = false
          })
      },
      onKeyUp() {
        const searchTerm = this.apiParams.imeiSearch ? this.apiParams.imeiSearch.trim() : ''
        const normalizedSearchTerm = searchTerm.toLowerCase()
        let hasExactMatch = false

        const filtered = this.productsTerm.filter((productImei) => {
          const imeis = this.normalizeImeiCode(productImei.imeiCode).toLowerCase()

          if (normalizedSearchTerm && imeis === normalizedSearchTerm) {
            productImei.selected = true
            hasExactMatch = true
          }

          return imeis.includes(normalizedSearchTerm)
        })

        if (hasExactMatch) {
          this.apiParams.imeiSearch = ''
          this.currentPage = 1
          this.products = cloneDeep(this.productsTerm)
          return
        }

        if (filtered.length <= this.perPage) {
          this.currentPage = 1
        }

        this.products = filtered
      },
      onApplyProducts() {
        const { imeiString, quantity } = applyChooseImeis(this.products)
        this.productItem.IMEI = imeiString
        this.productItem[this.quantityKey] = quantity
        if (this.$refs['modal-choose-imei']) {
          this.$refs['modal-choose-imei'].hide()
        }
      },
      normalizeImeiCode(value) {
        return normalizeImeiCodeFn(value)
      },
      validateImeiCode(imeiCode) {
        const code = this.normalizeImeiCode(imeiCode)
        if (!code) {
          return { valid: false, message: 'Mã IMEI không được để trống!' }
        }
        if (code.length > 20) {
          return {
            valid: false,
            message: `Mã IMEI ${code} vượt quá số ký tự cho phép (tối đa 20 ký tự)!`,
          }
        }

        if (/\s/.test(code)) {
          return {
            valid: false,
            message: `Mã IMEI ${code} không được chứa khoảng trắng!`,
          }
        }

        if (!/^[a-zA-Z0-9/_-]+$/.test(code)) {
          return {
            valid: false,
            message: `Mã IMEI ${code} không được chứa ký tự đặc biệt (chỉ cho phép chữ cái, số, /, - và _)!`,
          }
        }

        return { valid: true, message: '' }
      },
      getIndexItem(imeiCode) {
        const needle = this.normalizeImeiCode(imeiCode)
        const index = this.inputImeis.findIndex(
          (item) => this.normalizeImeiCode(item.imeiCode) === needle,
        )
        if (index < 0) {
          makeToastFaile(`Không tìm thấy mã IMEI ${imeiCode} trong danh sách`)
          throw new Error(`Không tìm thấy mã IMEI ${imeiCode} trong danh sách`)
        }
        return index
      },
      onKeyUpImeiInput() {
        const imeiCode = this.imeiInput?.trim() || ''
        if (!imeiCode) {
          return
        }

        // Validate IMEI code
        const validation = this.validateImeiCode(imeiCode)
        if (!validation.valid) {
          return makeToastFaile(validation.message)
        }
        const index = this.inputImeis.findIndex(
          (item) => this.normalizeImeiCode(item.imeiCode) === imeiCode,
        )
        if (index > -1) {
          return makeToastFaile(`Mã IMEI ${imeiCode} đã tồn tại trong danh sách`)
        }
        const imei = {
          imeiCode,
          selected: true,
        }
        this.inputImeis.push(imei)
        this.imeiInput = ''
      },
      onRemoveImei(imeiCode) {
        const index = this.getIndexItem(imeiCode)
        if (index > -1) {
          this.inputImeis.splice(index, 1)
        }
      },
      onApplyImeis() {
        const { imeiString, quantity } = applyManualImeis(this.inputImeis)
        this.productItem.IMEI = imeiString
        this.productItem[this.quantityKey] = quantity
        if (this.$refs['modal-input-imei']) {
          this.$refs['modal-input-imei'].hide()
        }
      },
      formatImeiList() {
        if (!this.productItem.IMEI) {
          return ''
        }

        const listImei = this.productItem.IMEI.split(',')
        const listImeiNo = listImei.map((imei, index) => {
          const no = index + 1
          return no + ') ' + imei
        })

        return listImeiNo.join('\r\n')
      },
      showModalImport(fromChooseModal = false) {
        this.importFromChooseModal = fromChooseModal
        this.$refs.importImeiModal.showModal()
      },
      applyImportedImeisToChooseList(imeiCodes) {
        const imported = (imeiCodes || [])
          .map((row) => this.normalizeImeiCode(row?.imeiCode))
          .filter((code) => !!code)
        if (!imported.length) {
          return makeToastFaile('Vui lòng nhập dữ liệu IMEI hợp lệ từ file excel')
        }
        const importedSet = new Set(imported)
        let matched = 0
        this.productsTerm.forEach((row) => {
          const code = this.normalizeImeiCode(row.imeiCode)
          if (importedSet.has(code)) {
            row.selected = true
            matched++
          }
        })
        if (matched === 0) {
          return makeToastFaile(
            'Không tìm thấy IMEI hợp lệ trong danh sách tồn kho của sản phẩm',
          )
        }
        this.apiParams.imeiSearch = ''
        this.onKeyUp()
        makeToastSuccess(
          `Đã chọn ${matched}/${importedSet.size} IMEI khớp từ file excel`,
        )
      },
      onSaveDataImportImei(imeiCodes) {
        if (this.importFromChooseModal) {
          this.importFromChooseModal = false
          this.applyImportedImeisToChooseList(imeiCodes)
          return
        }
        const normalized = (imeiCodes || []).map((row) => ({
          ...row,
          imeiCode: this.normalizeImeiCode(row.imeiCode),
        }))
        this.inputImeis = this.inputImeis.concat(normalized)
      },
    },
  }
</script>

<style scoped>
  ::v-deep(.hot-container .htCore td),
::v-deep(.hot-container .htCore th) {
  border: 1px solid #dee2e6 !important;
  border-radius: 0 !important;
  padding: 0.5rem 0.75rem !important;
  font-size: 14px;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  vertical-align: middle;
}

::v-deep(.hot-container .htCore td.current),
::v-deep(.hot-container .htCore th.current) {
  border-color: #0d6efd !important;
  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.25) !important;
  z-index: 2;
  position: relative;
}

::v-deep(.hot-container .ht_master .wtBorder) {
  display: none !important;
}

::v-deep(.hot-container .ht_clone_inline_start .htCore td) {
  border: 1px solid #dee2e6 !important;
  background-color: #f8f9fa;
  font-weight: 500;
  text-align: center;
  padding: 0.5rem !important;
  font-size: 14px;
  line-height: 1.5;
}

::v-deep(.hot-container .htCore tr) {
  height: 42px;
}

/* Modal Chọn IMEI: ô tìm + nút Excel cùng hàng, không tạo khoảng trống giữa */
.imei-choose-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px 12px;
}
.imei-choose-toolbar__search {
  flex: 1 1 240px;
  min-width: 160px;
  max-width: 100%;
}
.imei-choose-toolbar__excel {
  flex: 0 0 auto;
}
.imei-choose-toolbar__excel-btn {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.imei-choose-toolbar__excel-icon {
  font-size: 1rem;
}

.imei-selected-summary {
  white-space: normal;
  word-break: break-word;
  max-width: 220px;
  line-height: 1.35;
}
</style>

